// extracted by mini-css-extract-plugin
export default {"rootContainer":"CMSAssets_rootContainer__mAYSx","imgContainer":"CMSAssets_imgContainer__ryW6i","iconContainer":"CMSAssets_iconContainer__fhAXp","mt40":"CMSAssets_mt40__YsznQ"};